import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@shared/hooks/useAuth';

const HeroSection = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const dashboard = useMemo(() => {
    if (user) {
      return {
        days: user.travelDays || '365',
        diaries: user.diaryCount || '156',
        cities: user.checkinCities || '23',
      };
    }
    // 未登录：9月10日到今天
    const start = new Date('2025-09-10');
    const now = new Date();
    const days = Math.floor((now - start) / (1000 * 60 * 60 * 24));
    return {
      days: `${days}`,
      diaries: `${days}`,
      cities: '3',
    };
  }, [user]);

  return (
    <section className="relative min-h-screen flex items-center">
      {/* 背景：ChatGPT 深海场景 */}
      <div className="absolute inset-0 z-0">
        <img
          src="/bg-deep-sea.png"
          alt="深海夜晚"
          className="w-full h-full object-cover"
          style={{
            filter: 'saturate(0.7) brightness(0.6)',
            maskImage: 'linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.8) 100%)',
            WebkitMaskImage: 'linear-gradient(180deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.8) 100%)'
          }}
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(22,37,68,0.15) 0%, rgba(22,37,68,0.3) 50%, rgba(22,37,68,0.6) 100%)' }} />
      </div>

      {/* 内容 */}
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-5 gap-12 items-center w-full relative z-10 pt-28">
        <div className="lg:col-span-3" style={{ animation: 'rise .75s ease-out both' }}>
          <div className="ls ls-tl inline-flex items-center gap-2 mb-6">
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: 'var(--bloom)', boxShadow: '0 0 10px var(--bloom)' }} />
            AI 智能旅行规划
          </div>
          <h1 className="text-5xl lg:text-[68px] font-bold leading-[1.04] mb-6 tracking-tight is">
            <span className="cb">西蒙的猫<span style={{ color: "var(--gold, #ffd857)", margin: "0 0.1em" }}>·</span>旅行日记</span>
          </h1>
          <p className="text-lg cm leading-relaxed mb-10 max-w-md">
            陪你探索下一段旅程
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => navigate('/diaries')}
              className="bt btl"
              style={{ color: '#ffffff' }}
            >
              🐋 书写你的旅行叙事
            </button>
            <button
              onClick={() => navigate('/travel-ai')}
              className="bgm"
            >
              AI攻略
            </button>
          </div>
        </div>

        {/* 右侧卡片 - 深海探险家（大幅透明化） */}
        <div className="lg:col-span-2 hidden lg:block" style={{ animation: 'rise .75s ease-out both' }}>
          <div
            className="frost p-7 max-w-sm ml-auto"
            style={{
              background: 'rgba(8, 21, 38, 0.22)',
              border: '1px solid rgba(143, 169, 192, 0.14)',
              backdropFilter: 'blur(28px) saturate(1.3)',
              WebkitBackdropFilter: 'blur(28px) saturate(1.3)',
              borderRadius: '20px',
              boxShadow: '0 8px 40px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255,255,255,0.06)',
            }}
          >
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, var(--glow), var(--mid))', boxShadow: '0 4px 16px rgba(61,130,176,0.3)' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>
              </div>
              <div>
                <div className="text-sm font-semibold cb">深海探险家</div>
                <div className="text-[11px] cd">已连续航行 {dashboard.days} 天</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 mb-5">
              <div className="rounded-xl p-3" style={{ background: 'rgba(61,130,176,0.08)', border: '1px solid rgba(61,130,176,0.12)' }}>
                <div className="text-2xl font-bold cg">{dashboard.diaries}</div>
                <div className="text-[11px] cd mt-0.5">篇旅行日记</div>
              </div>
              <div className="rounded-xl p-3" style={{ background: 'rgba(212,168,83,0.07)', border: '1px solid rgba(212,168,83,0.12)' }}>
                <div className="text-2xl font-bold ca">{dashboard.cities}</div>
                <div className="text-[11px] cd mt-0.5">座打卡城市</div>
              </div>
            </div>
            <div className="rounded-xl p-3" style={{ background: 'rgba(22,37,68,0.4)', border: '1px solid rgba(156,200,224,0.08)' }}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-[11px] cd">探索进度</span>
                <span className="text-[11px] cg font-semibold">78%</span>
              </div>
              <div className="h-1 rounded-full" style={{ background: 'rgba(156,200,224,0.1)' }}>
                <div className="h-full rounded-full" style={{ width: '78%', background: 'linear-gradient(90deg, var(--mid), var(--bloom))' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
